import { render, staticRenderFns } from "./NotificationSectionWrapper.vue?vue&type=template&id=6cdbe93e&"
import script from "./NotificationSectionWrapper.vue?vue&type=script&lang=ts&"
export * from "./NotificationSectionWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports